import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as fileManagerActions from '../../actions';
import { getSelectedNodeIDsInAllFolders } from '../../selectors/selectors';
import Checkbox from '../../../../../general/components/Checkbox/Checkbox';
import { getTableData } from '../../selectors/getTableData';
import { getCurrentNode } from '../../../breadcrumbs/selectors';
import { differenceWith } from 'lodash';

export const SelectorHeader = () => {
  const selectedNodeIDs = useSelector(getSelectedNodeIDsInAllFolders);
  const nodesInCurrentView = useSelector(getTableData);

  const currentNode = useSelector(getCurrentNode);
  const dispatch = useDispatch();

  // use Set.isSubsetOf
  const isChecked =
    selectedNodeIDs.length > 0 &&
    differenceWith(nodesInCurrentView, selectedNodeIDs, (node, num) => node.id === num).length ===
      0;
  // console.debug(selectedNodeIDs, nodesInCurrentView);
  const onChange = () =>
    dispatch(
      fileManagerActions.selectorAllChanged({
        nodes: nodesInCurrentView,
        newChecked: !isChecked,
        context: currentNode!,
      }),
    );

  return <Checkbox onChange={onChange} isChecked={isChecked} label="" />;
};
